import { VStack, HStack } from '@chakra-ui/react'

import {
  OrderedList,
  UnorderedList,
  Paragraph,
  TabButton,
} from '@/features/Courses/components/CourseNavigation'
import { useCourseContext } from '@/features/Courses/contexts/CourseContext'

import { Tab } from '@/features/Courses/types'

interface Props {
  tabs: Tab[]
}

function CourseNavigation({ tabs }: Props): React.ReactElement {
  const course = useCourseContext()

  return (
    <VStack spacing="1" sx={{ alignItems: 'stretch' }}>
      <HStack
        sx={{
          pb: '10',
          display: {
            base: 'none',
            sm: 'flex',
          },
        }}
      >
        {tabs.map((tab) => {
          return <TabButton {...tab} key={tab.key} />
        })}
      </HStack>
      <VStack spacing="7" sx={{ alignItems: 'stretch' }}>
        {tabs.map((tab) => {
          const value = (course as any)[tab.key]

          if (!value) return

          if (tab.type === 'ordered-list') {
            return (
              <OrderedList
                key={tab.key}
                id={tab.hash}
                title={tab.label}
                items={value}
              />
            )
          }

          if (tab.type === 'unordered-list') {
            return (
              <UnorderedList
                key={tab.key}
                id={tab.hash}
                title={tab.label}
                items={value}
              />
            )
          }

          return (
            <Paragraph
              key={tab.key}
              id={tab.hash}
              title={tab.label}
              paragraph={value}
            />
          )
        })}
      </VStack>
    </VStack>
  )
}

export default CourseNavigation
